module.exports = __webpack_public_path__ + "static/image/sustainability/img-protection-2.ver2_0_2.png?44160465";